<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 1000px;" role="document">
                <div class="modal-content" style="width: 1000px;">
                    <div class="modal-header">
                        <h5 class="modal-title">Log data</h5>
                        <button type="button" class="close" data-dismiss="modal" @click="close" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-html="this.$parent.exportCsvHtml"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="copyToClipboard"  >
                            {{ $t('copyToClipboard') }}
                        </button>
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
export default {
    name: "rowDeleteModal",
    methods: {
        close() {
            this.$emit("close");
        },
        async copyToClipboard() {
            await navigator.clipboard.writeText(this.$parent.exportCsvHtml)
        }
    }
};
</script>
